//* Styles
import { Container, Text, useUi } from '@weareconceptstudio/core';
import AboutStyle from './style';
import Button from '@/components/Button';
import { config } from '@/helpers';
import { useEffect, useRef } from 'react';
import TitleAnim from '@/animation';

//* Component

const About = ({ title, description, infos }) => {
	const infosWrapRef = useRef(null);
	const aboutRef = useRef(null);
	const titleRefs = useRef([]);
	const subtitleRefs = useRef([]);
	const aboutDescRef = useRef();
	const aboutTitleRef = useRef();
	const buttonRef = useRef();

	const { winWidth } = useUi();

	useEffect(() => {
		if (!infosWrapRef.current && !aboutRef.current) return;
		if (window.innerWidth >= 768) {
			const heightLastChild = infosWrapRef.current.children[2].clientHeight;

			aboutRef.current.style.transform = `translateY(${-heightLastChild + 'px'})`;
			aboutRef.current.style.marginBottom = `${-heightLastChild}px`;
		}
	}, [winWidth]);

	return (
		<AboutStyle>
			<TitleAnim
				triggerRef={aboutTitleRef}
				animType='title'
				animRef={aboutTitleRef}
			/>

			<TitleAnim
				triggerRef={aboutTitleRef}
				animType='subtitle'
				animRef={aboutDescRef}
				finishPercent={0.2}
				onFinish={() => {
					buttonRef?.current?.classList?.add('active-button');
				}}
				onBack={() => {
					buttonRef?.current?.classList?.remove('active-button');
				}}
			/>
			{titleRefs.current.length
				? titleRefs.current.map((item, index, arr) => {
						return (
							<TitleAnim
								triggerRef={arr[0]}
								key={index}
								animType='title'
								animRef={item}
								configAnim={{ delay: 0.15 * index }}
								setVars={{ rotateZ: 10 }}
							/>
						);
					})
				: null}

			{subtitleRefs.current.length
				? subtitleRefs.current.map((item, index, arr) => {
						return (
							<TitleAnim
								triggerRef={titleRefs.current[0]}
								key={index}
								animType='subtitle'
								animRef={item}
								configAnim={{ delay: 0.2 * index }}
							/>
						);
					})
				: null}
			<Container row>
				<div className='col-4 col-dx-5 col-m-12'>
					<div
						ref={infosWrapRef}
						className='infos-wrap'>
						{infos.map((item, index) => {
							return (
								<div
									key={index}
									className='info-item'>
									<Text
										ref={(el) => (titleRefs.current[index] = { current: el })}
										className={'white-1000 h3  montserrat-500 title-info'}>
										{item.title}
									</Text>
									<Text
										ref={(el) => (subtitleRefs.current[index] = { current: el })}
										className={'white-1000 p2  montserrat-500 description-info'}>
										{item.description}
									</Text>
								</div>
							);
						})}
					</div>
				</div>
				<div className='col-8 col-dx-7 col-m-12'></div>
			</Container>
			<Container row>
				<div className='col-6 col-dx-5 col-m-12'></div>

				<div className='col-6 col-dx-7 col-m-12'>
					<div
						ref={aboutRef}
						className='wrapper-about'>
						<Text
							ref={aboutTitleRef}
							className={'white-1000 h2  montserrat-400 title'}>
							{title}
						</Text>
						<Text
							ref={aboutDescRef}
							className={'white-1000 p1  montserrat-400 description'}>
							{description}
						</Text>
						<div
							ref={buttonRef}
							className='wrapper-button '>
							<Button
								url={config.routes.aboutUs.path}
								text={config.routes.aboutUs.name}
							/>
						</div>
					</div>
				</div>
			</Container>
		</AboutStyle>
	);
};

export default About;
